import { bool, func, number } from 'prop-types';
import React from 'react';

import withConfirm from '../../../../generic/with-confirm';
import { allStatusesEnum as invoiceStatuses } from '../../../constants';
import ApproveTooltipButton from './ApproveTooltipButton';

const ButtonWithConfirmation = withConfirm(
  'Do you really want to approve this invoice?',
)(ApproveTooltipButton);

export default function ApproveButton({
  onUpdateStatus,
  id,
  disabled,
  ...rest
}) {
  return (
    <ButtonWithConfirmation
      onClick={() => onUpdateStatus(id, invoiceStatuses.APPROVED.value)}
      disabled={disabled}
      {...rest}
    />
  );
}

ApproveButton.propTypes = {
  onUpdateStatus: func.isRequired,
  id: number.isRequired,
  disabled: bool,
};

ApproveButton.defaultProps = {
  disabled: false,
};
